import { EatableSource } from 'Models'

export const mapEatableSourceToFormValue = <Empty extends null | undefined>(
  source: EatableSource | null | undefined,
  empty: Empty
): EatableSource | Empty => source ?? empty
